<app-generic-toolbar
  [toolbarOptions]="toolbarOptions"
></app-generic-toolbar>
<div *ngIf="downLoadInProgress" class="downloading-spinner">
  <app-progress-bar-circular></app-progress-bar-circular>
  <div class="message">Preparing your download. This may take a few minutes...</div>
</div>
<iframe
  #iframe
  title="HTML Viewer"
  [src]="safeUrl"
></iframe>

